// extracted by mini-css-extract-plugin
module.exports = {"header":"MainNavigation_header__3bfhq","logo":"MainNavigation_logo__2F3wT","nav":"MainNavigation_nav__rJgfB","active":"MainNavigation_active__221cL"};